import { combineEpics } from 'redux-observable';

import { createLocationEpic } from './CreateLocation/CreateLocationEpic';
import { deleteLocationEpic } from './DeleteLocation/DeleteLocationEpic';
import { findLocationsEpic } from './FindLocations/FindLocationsEpic';
import { findLocationEpic }   from './FindLocation/FindLocationEpic';
import { updateLocationEpic } from './UpdateLocation/UpdateLocationEpic';


export const locationEpics = combineEpics(
  createLocationEpic,
  deleteLocationEpic,
  findLocationsEpic,
  findLocationEpic,
  updateLocationEpic,
);
